import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import Hidden from '@material-ui/core/Hidden';
import Collapse from '@material-ui/core/Collapse';
import SearchIcon from '@material-ui/icons/Search';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import MenuIcon from '@material-ui/icons/Menu';
import HeaderStyles from '../../styles/Header';
import { withRouter } from 'react-router-dom';
import client from './../../utils/apolloClient';
import gql from 'graphql-tag';
import { Typography } from '@material-ui/core';
import { getUser } from './../../data-services/queries/index';
import getData from '../../data-services/api';
const query = gql`
    {
        searchBarVisiblity @client
    }
`;

class Header extends Component {
    state = {
        anchorEl: null,
        searchExpanded: false,
        name: '',
        userData: null,
    };

    handleSettingdToggle = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    handleCloseMenu = () => {
        this.setState({ anchorEl: null });
    };

    handleSearch = (e) => {
        if (this.props.handleSearch) {
            this.props.handleSearch(e.target.value);
        }
        return e.preventDefault();
    };

    handleSearchExpandToggle = () => {
        this.setState({ searchExpanded: !this.state.searchExpanded });
    };

    handleDrawerToggle = () => {
        this.props.toggleDrawer();
        if (this.state.searchExpanded) this.handleSearchExpandToggle();
    };

    handleNotificationToggle = () => {
        this.props.toogleNotifications();
        if (this.state.searchExpanded) this.handleSearchExpandToggle();
    };

    handleResetPassword = () => {
        this.props.history.push({
            pathname: '/ForgetPassword',
            state: this.state.userData,
        });
    };

    handleSignOut = () => {
        client
            .mutate({
                mutation: gql`
                    mutation Logout {
                        logout @client
                    }
                `,
            })
            .then((r) => {
                this.props.history.replace('/signin');
            });
        if (localStorage.getItem('fcpLogoutMS') !== '') {
            localStorage.removeItem('fcpLogoutMS');
        }
        localStorage.removeItem('token');
        localStorage.removeItem('FCPHPAList');
        localStorage.removeItem('authData');
    };

    componentDidMount = async () => {
        client
            .watchQuery({
                query: query,
            })
            .subscribe(({ data }) => {
                this.setState({
                    searchBarVisiblity: data.searchBarVisiblity,
                });
            });

        client
            .query({
                query: gql(getUser),
            })
            .then(({ data: { user } }) => {
                this.setState({ userData: user });
                if (user.id && user.role) {
                    if (user.role === 'FCP') {
                        getData(`select * from salesforce.account where sfid='${user.sfid}'`).then(
                            (data) => {
                                this.setState({
                                    name: data.result[0].name.split(' ')[0],
                                });
                            }
                        );
                    } else {
                        getData(
                            `Select * from salesforce.Pidilite_User__c where id = '${
                                user.id
                            }'  and type__c='${user.role}'`
                        ).then((data) => {
                            this.setState({
                                name: data.result[0].name.split(' ')[0],
                            });
                        });
                    }
                }
            });
    };

    render() {
        const { classes, toggleFullscreen, showMenu } = this.props;
        const { anchorEl, searchExpanded } = this.state;
        return (
            <AppBar position="static" className={classes.appBar}>
                <Toolbar className={classes.toolBar}>
                    {showMenu ? (
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            onClick={this.handleDrawerToggle}
                        >
                            <MenuIcon />
                        </IconButton>
                    ) : null}

                    <div className={classes.branding}>
                        <Typography variant="headline">Hi, {this.state.name}</Typography>
                        {/* <img src={logo} alt={logoAltText} className={classes.logo} /> */}
                    </div>

                    {this.state.searchBarVisiblity ? (
                        <Hidden xsDown>
                            <div className={classes.searchWrapper}>
                                <form
                                    autocomplete="off"
                                    onSubmit={(e) => e.preventDefault()}
                                    className={classes.searchForm}
                                >
                                    <IconButton aria-label="Search" className={classes.searchIcon}>
                                        <SearchIcon />
                                    </IconButton>
                                    <input
                                        name="searchVal"
                                        onChange={this.handleSearch}
                                        className={classes.searchInput}
                                        type="text"
                                        placeholder="Search"
                                        autoFocus={true}
                                    />
                                </form>
                            </div>
                        </Hidden>
                    ) : (
                        <div className={classes.searchWrapper} />
                    )}

                    <Hidden smUp>
                        <span className="flexSpacer" />
                    </Hidden>

                    <Hidden smUp>
                        {this.state.searchBarVisiblity ? (
                            <IconButton
                                color="inherit"
                                onClick={this.handleSearchExpandToggle}
                                aria-expanded={searchExpanded}
                                aria-label="Show searchbar"
                            >
                                <SearchIcon />
                            </IconButton>
                        ) : null}
                    </Hidden>

                    <Hidden xsDown>
                        <IconButton color="inherit" onClick={toggleFullscreen}>
                            <FullscreenIcon />
                        </IconButton>
                    </Hidden>

                    {/* <IconButton color="inherit" onClick={this.handleNotificationToggle}>
            <Badge badgeContent={5} color="secondary">
              <NotificationsIcon />
            </Badge>
          </IconButton> */}

                    <IconButton
                        aria-label="User Settings"
                        aria-owns={anchorEl ? 'user-menu' : null}
                        aria-haspopup="true"
                        color="inherit"
                        onClick={this.handleSettingdToggle}
                    >
                        <MoreVertIcon />
                    </IconButton>

                    <Menu
                        id="user-menu"
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={this.handleCloseMenu}
                    >
                        {/* <MenuItem onClick={this.handleCloseMenu}>
              <ListItemIcon>
                <SettingsIcon />
              </ListItemIcon>
              <ListItemText inset primary="Settings" />
            </MenuItem> */}
                        {/* <MenuItem onClick={this.handleCloseMenu}>
              <ListItemIcon>
                <AccountBoxIcon />
              </ListItemIcon>
              <ListItemText inset primary="Profile" />
            </MenuItem> */}
                        {/* <MenuItem onClick={this.handleCloseMenu}>
              <ListItemIcon>
                <NotificationsOffIcon />
              </ListItemIcon>
              <ListItemText inset primary="Disable notifications" />
            </MenuItem> */}
                        <MenuItem onClick={this.handleCloseMenu}>
                            <ListItemIcon>
                                <VpnKeyIcon />
                            </ListItemIcon>
                            <ListItemText
                                onClick={this.handleResetPassword}
                                inset
                                primary="Reset Password"
                            />
                        </MenuItem>
                        <MenuItem onClick={this.handleCloseMenu}>
                            <ListItemIcon>
                                <ExitToAppIcon />
                            </ListItemIcon>
                            <ListItemText onClick={this.handleSignOut} inset primary="Sign out" />
                        </MenuItem>
                    </Menu>
                </Toolbar>
                <Hidden smUp>
                    <Collapse in={searchExpanded} timeout="auto" unmountOnExit>
                        <Toolbar className={classes.toolBar}>
                            <div className={classes.searchWrapper}>
                                <form
                                    autocomplete="off"
                                    onSubmit={(e) => e.preventDefault()}
                                    className={classNames(classes.searchForm, 'mr-0')}
                                >
                                    <IconButton aria-label="Search" className={classes.searchIcon}>
                                        <SearchIcon />
                                    </IconButton>
                                    <input
                                        name="searchVal"
                                        className={classes.searchInput}
                                        type="text"
                                        onChange={this.handleSearch}
                                        placeholder="Search"
                                        autoFocus="true"
                                    />
                                </form>
                            </div>
                        </Toolbar>
                    </Collapse>
                </Hidden>
            </AppBar>
        );
    }
}

Header.prototypes = {
    classes: PropTypes.object.isRequired,
    logo: PropTypes.string,
    logoAltText: PropTypes.string,
};

export default withRouter(withStyles(HeaderStyles)(Header));
